import type {AmplitudeOfferPromotionLocation} from "../../../promotion/tracking/get_amplitude_offer_promotion_event_properties";
import type {IAmplitudeLeadFormProductData} from "./get_amplitude_lead_form_products";

export type AmplitudeLeadFormLocation = AmplitudeOfferPromotionLocation | "listing_page" | "homepage_banner";

export const getAmplitudeFormLocation = (leadData: IAmplitudeLeadFormProductData | undefined, preferredLocation?: string): AmplitudeLeadFormLocation => {
    if (preferredLocation === "investment_page" || preferredLocation === "property_page") {
        return preferredLocation;
    }

    if (leadData?.property?.detail) {
        return "property_page";
    }

    return "investment_page";
};
import type {AmplitudeOfferPromotionLocation} from "../../../promotion/tracking/get_amplitude_offer_promotion_event_properties";
import type {IAmplitudeLeadFormProductData} from "./get_amplitude_lead_form_products";

export type AmplitudeLeadFormLocation = AmplitudeOfferPromotionLocation | "listing_page" | "homepage_banner";

export const getAmplitudeFormLocation = (leadData: IAmplitudeLeadFormProductData | undefined, preferredLocation?: string): AmplitudeLeadFormLocation => {
    if (preferredLocation === "investment_page" || preferredLocation === "property_page") {
        return preferredLocation;
    }

    if (leadData?.property?.detail) {
        return "property_page";
    }

    return "investment_page";
};
